import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="passage-slide"
// Handles slide toggle functionality for passage review pages
export default class extends Controller {
  connect() {
    this.initializeSlides()
  }

  initializeSlides() {
    // Hide all answer lists initially
    window.$("td ul").hide()

    // Set up opener click handlers for showing/hiding answers
    window.$(".opener").off('click').on('click', (event) => {
      event.preventDefault()
      const itemData = window.$(event.currentTarget).attr("itemdata")
      const alphabets = window.$("#alphabets_" + itemData)
      const opener = window.$(event.currentTarget)

      alphabets.slideToggle(100)
      opener.text(opener.text() == 'Show Answer' ? "Hide Answer" : "Show Answer")
      opener.toggleClass("toggler-pad")
    })

    // Set up image top click handlers for showing/hiding questions
    window.$(".img_top1").off('click').on('click', (event) => {
      event.preventDefault()
      const itemData = window.$(event.currentTarget).attr("itemdata")
      const hideSection = window.$("#hide-section_" + itemData)
      const tr = window.$("#tr_" + itemData)
      const imgTop = window.$("#img_top_" + itemData + " i")
      const ansOpener = window.$("#ans-opener_" + itemData)

      if (hideSection.css('display') == 'none') {
        tr.find("td").addClass("top-align")
      } else {
        tr.find("td").addClass("top-align")
      }

      hideSection.slideToggle(400)
      imgTop.toggle()
      ansOpener.text(ansOpener.text() == 'Show Question' ? "Hide Question" : "Show Question")
    })

    // Set up ans-opener click handlers
    window.$("td.ans .ans-opener").off('click').on('click', (event) => {
      event.preventDefault()
      const itemData = window.$(event.currentTarget).attr("itemdata")
      const hideSection = window.$("#hide-section_" + itemData)
      const tr = window.$("#tr_" + itemData)
      const imgTop = window.$("#img_top_" + itemData + " i")
      const ansOpener = window.$(event.currentTarget)

      tr.find("td").addClass("top-align")
      hideSection.slideToggle(400)
      ansOpener.text(ansOpener.text() == 'Show Question' ? "Hide Question" : "Show Question")
      imgTop.toggle()
    })

    // Set up que ans-opener click handlers
    window.$("td.que .ans-opener").off('click').on('click', (event) => {
      event.preventDefault()
      const itemData = window.$(event.currentTarget).attr("itemdata")
      const hideSection = window.$("#hide-section_" + itemData)
      const answerShowed = window.$("#answer-showed_" + itemData)
      const imgTop = window.$("#img_top_" + itemData + " i")

      hideSection.slideToggle()
      answerShowed.slideToggle(500)
      imgTop.toggle()
    })

    // Set up to-do-toggle handlers
    window.$(".open-block").hide()
    window.$(".to-do-toggle").off('click').on('click', (event) => {
      event.preventDefault()
      const target = window.$(event.currentTarget).attr('target')
      window.$("#open-block" + target).slideToggle(300)
      window.$(".to-do-toggle i").toggle()
    })
  }
}
